import type { QuoteFieldErrors, QuoteRequestInput, ServiceKey } from '@/types'

export const SERVICE_KEYS: Array<ServiceKey> = ['web-design', 'seo', 'print']

export const QUOTE_LIMITS = {
    name: 80,
    email: 254,
    message: 5000
}

const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[a-z]{2,}$/i

const singleLine = (value: string): string => value.replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim()

/** Turns untrusted input into a clean quote request: trimmed text, known services only. */
export const normalizeQuote = (raw: unknown): QuoteRequestInput => {
    const source = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>
    const text = (key: string): string => (typeof source[key] === 'string' ? (source[key] as string) : '')
    const services = Array.isArray(source.services)
        ? source.services.filter((item): item is ServiceKey => SERVICE_KEYS.includes(item as ServiceKey))
        : []

    return {
        firstName: singleLine(text('firstName')),
        lastName: singleLine(text('lastName')),
        email: singleLine(text('email')).toLowerCase(),
        services: Array.from(new Set(services)),
        message: text('message').replace(/\r\n/g, '\n').trim(),
        website: singleLine(text('website'))
    }
}

export const validateQuote = (input: QuoteRequestInput): QuoteFieldErrors => {
    const errors: QuoteFieldErrors = {}

    if (!input.firstName) errors.firstName = "Please add your first name."
    else if (input.firstName.length > QUOTE_LIMITS.name) errors.firstName = "Please shorten your first name."

    if (!input.lastName) errors.lastName = "Please add your last name."
    else if (input.lastName.length > QUOTE_LIMITS.name) errors.lastName = "Please shorten your last name."

    if (!input.email) errors.email = "Please add your email address."
    else if (input.email.length > QUOTE_LIMITS.email || !EMAIL_PATTERN.test(input.email)) errors.email = "That email address doesn't look quite right."

    if (!input.message) errors.message = "Tell us a little about your business and project."
    else if (input.message.length > QUOTE_LIMITS.message) errors.message = `Please keep your message under ${QUOTE_LIMITS.message} characters.`

    return errors
}
